"use client";

import { CategoryScale, ChartData, ChartOptions } from "chart.js";
import { Chart } from "chart.js/auto";
import { Line } from "react-chartjs-2";

Chart.register(CategoryScale);

export type LineChartParams = {
  data: ChartData<"line">;
  options?: ChartOptions<"line">;
};

const LineChart = ({ data, options }: LineChartParams) =>
  data ? <Line data={data} options={options} /> : null;

export default LineChart;
